import * as UserAPI from "../api/user";
import * as DummyUserAPI from "../dummyApi/user";
import { isDemoMode } from "../stores/mode";
import type { UserData, UserDataInput } from "../api/user";
import type { ApiResponse } from "../../types/api";

interface UserApi {
  getUser: () => Promise<UserData | undefined>,
  updateUser: (userData: UserDataInput) => Promise<ApiResponse>,
  updateUserMetadata: (metadata: Record<string, unknown>) => Promise<void>,
  validateIdentifier: (identifier: string, jwt: string) => Promise<ApiResponse>,
  saveUserSettings: (settings: Record<string, unknown>) => Promise<ApiResponse>,
  validateEntry: (entryGateData: Record<string, string | number>) => Promise<ApiResponse>
}

const getAPI = (): UserApi => {
  return isDemoMode()
    ? DummyUserAPI
    : UserAPI;
};

export const getUser = async (): Promise<UserData | undefined> => {
  return getAPI().getUser();
};

export const updateUser = async (userData: UserDataInput): Promise<ApiResponse> => {
  return getAPI().updateUser(userData);
};

export const updateUserMetadata = async (metadata: Record<string, unknown>): Promise<void> => {
  return getAPI().updateUserMetadata(metadata);
};

export const validateIdentifier = async (identifier: string, jwt: string): Promise<ApiResponse> => {
  return getAPI().validateIdentifier(identifier, jwt);
};

export const saveUserSettings = async (settings: Record<string, unknown>): Promise<ApiResponse> => {
  return getAPI().saveUserSettings(settings);
};

export const validateEntry = async (entryGateData: Record<string, string | number>): Promise<ApiResponse> => {
  return getAPI().validateEntry(entryGateData);
};
